"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _HtmlInput = _interopRequireDefault(require("./HtmlInput"));

var _core = require("@emotion/core");

var Input =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Input, _React$PureComponent);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleOnBlur = function (event) {
      var _this$props = _this.props,
          max = _this$props.max,
          min = _this$props.min,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          type = _this$props.type;

      if (type === 'number') {
        var valueHasChanged = false;

        if (min !== undefined && min !== null && event.target.value < min) {
          event.target.value = min;
          valueHasChanged = true;
        }

        if (max !== undefined && event.target.value > max) {
          event.target.value = max;
          valueHasChanged = true;
        }

        if (onChange && valueHasChanged) {
          onChange(event);
        }
      }

      if (onBlur) {
        onBlur(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Input, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ariaDescribedBy = _this$props2.ariaDescribedBy,
          ariaInvalid = _this$props2.ariaInvalid,
          ariaLabel = _this$props2.ariaLabel,
          ariaReadOnly = _this$props2.ariaReadOnly,
          uia = _this$props2.uia,
          innerRef = _this$props2.innerRef,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["ariaDescribedBy", "ariaInvalid", "ariaLabel", "ariaReadOnly", "uia", "innerRef"]);
      return (0, _core.jsx)(_HtmlInput.default, (0, _extends2.default)({
        ref: innerRef,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": ariaInvalid,
        "aria-label": ariaLabel,
        "aria-readonly": ariaReadOnly,
        "data-uia-input": uia
      }, props, {
        onBlur: this.handleOnBlur
      }));
    }
  }]);
  return Input;
}(_react.default.PureComponent);

Input.defaultProps = {
  type: 'text',
  variant: 'default'
};
var _default = Input;
exports.default = _default;